import moment from "moment";

import { Reservation } from "models/Reservation";

export function getReservationsSortedByStartDate(reservations: Array<Reservation>): Array<Reservation> {
    return [ ...reservations ].sort((a, b) => moment(a.start).valueOf() - moment(b.start).valueOf());
}